
import { FileHelper } from "../../../helpers/file-helper";

export class ImageSrcValueConverter {
    toView(path: string): string {
        if (path) {
            const ext = FileHelper.getFileExtension(path);
            path = path.replace('.' + ext, '');
            path = path.startsWith('/') ? path.substring(1) : path;
            let p2 = path;
            switch (ext) {
                case 'jpg':
                    p2 = require('../../../' + path + '.jpg');
                    break;
                case 'jpeg':
                    p2 = require('../../../' + path + '.jpeg');
                    break;
                case 'png':
                    p2 = require('../../../' + path + '.png');
                    break;
                case 'gif':
                    p2 = require('../../../' + path + '.gif');
                    break;
                case 'svg':
                    p2 = require('../../../' + path + '.svg');
                    break;
                case 'webp':
                    p2 = require('../../../' + path + '.webp');
                    break;
            }
            return p2;
        }

        return path;
    }
}
